import { Link } from "react-router-dom";
import { Globe } from "lucide-react";
import { imgSrc } from "@/lib/api";
import { scrollToContact } from "@/components/site/Chrome";
import { CurrencySwitcher } from "@/components/site/CurrencySwitcher";
import { Price } from "@/context/CurrencyContext";

export const InternationalShowcase = ({ items, onSeeAll }) => (
  <section className="bg-gw-ground text-white py-20 md:py-28" data-testid="international-showcase">
    <div className="max-w-6xl mx-auto px-6">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-10">
        <div>
          <p className="lab text-gw-mist inline-flex items-center gap-2"><Globe size={13} /> Beyond borders</p>
          <h2 className="lux gw-h2 mt-4">International properties</h2>
          <p className="gw-body text-gw-pale mt-4 max-w-xl">Homes and investments abroad, with the same honest advice on every deal.</p>
        </div>
        {items.length > 0 && (
          <div className="flex flex-wrap items-start gap-4">
            <CurrencySwitcher dark testPrefix="intl-currency" />
            <button type="button" onClick={onSeeAll} data-testid="international-see-all"
              className="group lab border border-white/50 px-5 py-3 inline-flex gap-2 transition-colors duration-200 hover:bg-white/10">
              See all international <span className="transition-transform duration-200 group-hover:translate-x-1">→</span>
            </button>
          </div>
        )}
      </div>
      {items.length === 0 ? (
        <div className="border border-white/25 p-8 md:p-10 flex flex-wrap items-center justify-between gap-6" data-testid="international-empty">
          <p className="gw-body text-gw-pale max-w-xl">Our international listings will appear here. Tell us the country you're looking at and we'll share what's available.</p>
          <button type="button" onClick={scrollToContact} data-testid="international-enquire"
            className="lab bg-white text-gw-onwhite px-6 py-4 transition-colors duration-200 hover:bg-gw-mist">Ask about a country</button>
        </div>
      ) : (
        <div className="grid md:grid-cols-3 gap-6">
          {items.slice(0, 3).map((p, i) => (
            <Link key={p.id} to={`/realty/${p.id}`} className="group block" data-testid={`international-card-${i}`}>
              <figure className="relative overflow-hidden aspect-[4/5] bg-gw-mid m-0">
                {p.images?.[0] && <img src={imgSrc(p.images[0])} alt={p.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />}
                <span className="lab absolute top-3 left-3 bg-white/90 text-gw-onwhite px-2 py-1 inline-flex items-center gap-1.5"><Globe size={12} /> {p.country || "International"}</span>
              </figure>
              <p className="lux text-2xl mt-3">{p.title}</p>
              <p className="text-sm text-gw-pale">
                {[p.listing_type, p.location].filter(Boolean).join(" · ")}
                {p.price && <> · <Price price={p.price} testId={`international-card-price-${i}`} /></>}
              </p>
            </Link>
          ))}
        </div>
      )}
    </div>
  </section>
);
